import { Redirect, usePathname } from 'expo-router';
import React from 'react';
import { isWeb } from 'smoothie';

import type { ContainerComponent } from '../../../common/types/Common';
import { useUserAuthorization } from '../../hooks/useUserAuthorization';
import {
    AuthorizationLevel,
    LimitedAccessScope,
} from '../../types/UserAuthorization';

const HandleRedirectFromAuthorization: ContainerComponent = ({ children }) => {
    const { authorizationLevel, limitedAccessScope } = useUserAuthorization();

    const pathname = usePathname();

    switch (authorizationLevel) {
        case AuthorizationLevel.NO_ACCESS:
            return <Redirect href="/no-access" />;
        case AuthorizationLevel.LIMITED_ACCESS:
            switch (limitedAccessScope) {
                /* The following two cases point to routes in the legacy frontend app not currently in use. */

                // case LimitedAccessScope.SIGNUP_ONBOARDING:
                //     void Linking.openURL(
                //         `${getWebUrl({ useSignupAppOnLocal: true })}/sign-up/contact-info`,
                //     );
                //     // TODO: open a web page in the native browser, and show a friendlier more
                //     // contextualized version of no-access page with ability to reload / try again.
                //     return isWeb ? null : <Redirect href="/no-access" />;
                // case LimitedAccessScope.SIGNUP_CHECKOUT:
                //     void Linking.openURL(
                //         `${getWebUrl({ useSignupAppOnLocal: true })}/sign-up/checkout`,
                //     );
                //     // TODO: open a web page in the native browser, and show a friendlier more
                //     // contextualized version of no-access page with ability to reload / try again.
                //     return isWeb ? null : <Redirect href="/no-access" />;
                case LimitedAccessScope.KYC:
                    if (!isWeb) {
                        // Technically, we could allow these users to proceed like on web, but we haven't
                        // made the product choice to allow ths, the UI isn't tailored for native mobile yet
                        return <Redirect href="/no-access" />;
                    }
                    if (
                        pathname.startsWith('/banking/kyc') ||
                        pathname.startsWith('/settings')
                    ) {
                        return <>{children}</>;
                    }
                    return <Redirect href="/banking/kyc" />;
                case LimitedAccessScope.BANKING:
                    if (!isWeb) {
                        // Technically, we could allow these users to proceed like on web, but we haven't
                        // made the product choice to allow ths, the UI isn't tailored for native mobile yet
                        return <Redirect href="/no-access" />;
                    }
                    if (
                        pathname.startsWith('/banking') ||
                        pathname.startsWith('/settings')
                    ) {
                        return <>{children}</>;
                    }
                    return <Redirect href="/banking" />;
                case LimitedAccessScope.MEMBERSHIP_ONBOARDING:
                    if (
                        pathname.startsWith('/home') ||
                        pathname.startsWith('/onboarding') ||
                        pathname.startsWith('/roadmap') ||
                        // The Go flow leaves /roadmap for these after Income Split.
                        pathname.startsWith('/income-split') ||
                        pathname.startsWith('/banking/direct-deposit') ||
                        pathname.startsWith('/holistic/connect-institution') ||
                        pathname.startsWith(
                            '/holistic/edit-institution-account',
                        ) ||
                        pathname.startsWith('/holistic/edit-manual-account') ||
                        pathname.startsWith('/bills') ||
                        pathname.startsWith('/guidance-sessions') ||
                        pathname.startsWith('/settings') ||
                        pathname.startsWith('/my-guide/welcome-video')
                    ) {
                        return <>{children}</>;
                    }
                    return <Redirect href="/home" />;
                case LimitedAccessScope.FORMER_MEMBER:
                    return <Redirect href="/former-member" />;
                case LimitedAccessScope.NO_ACCESS:
                    return <Redirect href="/no-access" />;
                default:
                    return <>{children}</>;
            }
        case AuthorizationLevel.NORMAL_ACCESS:
        default:
            return <>{children}</>;
    }
};

export default HandleRedirectFromAuthorization;
